<div class="page-container">
  <div class="dashboard-header">
    <h3 class="dashboard-header-title">Статистика и отчёты</h3>
    @if (filterForm) {
    <form
      [formGroup]="filterForm"
      class="dashboard-filter-form flex justify-between items-center gap-2"
    >
      <ui-form-date [hideLabel]="true" formControlName="startDate"></ui-form-date>
      <ui-form-date [hideLabel]="true" formControlName="endDate"></ui-form-date>
      <ui-button (click)="onApplyFilter()">Применить</ui-button>
    </form>
    }
  </div>

  <div class="page-content">
    @if(isLoading) {
    <div class="flex justify-center items-center h-full">
      <ui-loading></ui-loading>
    </div>
    }@else {

    <ui-card class="m-6" title="Общая информация">
      <ng-container content>
        <aggregator-dashboard-general-info [data]="generalData"></aggregator-dashboard-general-info>
      </ng-container>
    </ui-card>

    <div class="flex gap-6 m-6">
      <div class="flex flex-1 flex-col gap-6">
        <ui-card title="Типы парковок">
          <ng-container content>
            <aggregator-dashboard-type-info
              [data]="parkingTypeData"
            ></aggregator-dashboard-type-info>
          </ng-container>
        </ui-card>

        <ui-card title="Категории парковок">
          <ng-container content>
            <aggregator-dashboard-type-info
              [data]="parkingCategoryData"
            ></aggregator-dashboard-type-info>
          </ng-container>
        </ui-card>

        <ui-card title="Опции парковок">
          <ng-container content>
            <aggregator-dashboard-type-info
              [data]="parkingOptionData"
            ></aggregator-dashboard-type-info>
          </ng-container>
        </ui-card>

        <ui-card title="Статус парковок">
          <ng-container content>
            <aggregator-dashboard-type-info
              [data]="parkingStatusData"
            ></aggregator-dashboard-type-info>
          </ng-container>
        </ui-card>
      </div>

      <ui-card class="flex-1" title="Средняя нагрузка на парковки (по районам)">
        <ng-container content>
          <aggregator-dashboard-city-map-chart></aggregator-dashboard-city-map-chart>
        </ng-container>
      </ui-card>
    </div>

    <ui-card class="m-6">
      <ng-container content>
        <div class="flex justify-between items-center py-2 mb-4">
          <h2 class="text-xl font-medium mb-4">Нагрузка парковок</h2>
          <div class="flex items-center space-x-2 mb-4">
            <div>Парковка:</div>
            <ui-form-select
              class="filter-select"
              [hideLabel]="true"
              requestUrl="parkings"
              [pageable]="true"
              [paginationType]="'page'"
              [showSearch]="true"
              [searchField]="'SearchTerm'"
              [optionLabelField]="'name'"
              [optionValueField]="'id'"
              [formControl]="parkingSelectControl"
              placeholder="Выберите парковку"
              [optionHeight]="28"
              [optionPadding]="'3px 12px 3px 16px'"
            >
            </ui-form-select>
            <ui-form-date
              class="filter-date"
              [hideLabel]="true"
              [formControl]="parkingDateControl"
            ></ui-form-date>
          </div>
        </div>
      </ng-container>
      <ng-container content>
        @if(isParkingListLoading) {
        <div class="flex justify-center items-center h-full" style="height: 300px">
          <ui-loading [text]="'Загрузка данных...'"></ui-loading>
        </div>
        }@else {
        <aggregator-dashboard-line-chart
          class="mt-3"
          [data]="parkingStatisticData"
        ></aggregator-dashboard-line-chart>
        }
      </ng-container>
    </ui-card>

    }
  </div>
</div>
